// extracted by mini-css-extract-plugin
export default {"breadcrumb-height":"56px","container":"styles_container__Ibl-J"};